import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative" data-id="element-137" data-mp="1j9gz2sqezjay">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-138" data-mp="1jas38tnrut2l">
        <div className="text-center mb-10" data-id="element-139" data-mp="1n9r33zunbzn6">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-navy" data-id="element-140" data-mp="1s9n6bwvirn1o">
            Your complete <span className="text-gold" data-id="element-141" data-mp="1x8qdpnyz25ct">Taekwondo Instructor Ready</span> package
          </h2>
          <p className="text-navy-medium text-sm md:text-base" data-id="element-142" data-mp="1x6vss9npad8q">
            The complete coaching system — ready for your next class.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-cream-beige border-2 border-gold rounded-3xl p-1 relative shadow-xl" data-id="element-143" data-mp="2w9y3wkadeva">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-144" data-mp="1hon7e3fgi916">
            <Sparkles size={14} data-id="element-145" data-mp="17ppaod7vn973" /> Complete Package
          </div>
          <div className="bg-cream-card rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-146" data-mp="25e7r4ojfpabi">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy mb-3" data-id="element-147" data-mp="20g68g4px7d0k">
              Taekwondo Instructor Ready — Complete{' '}
              <span className="text-gold" data-id="element-148" data-mp="1vjftxltrkph9">Coaching System</span>
            </h3>
            <p className="text-base text-ink mb-6" data-id="element-149" data-mp="1rf81bdk6qpdr">You receive:</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-cream-beige border border-gold-light rounded-xl p-4" data-id="element-150" data-mp="k2g1mq7f2an8">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-151" data-mp="hhrrat2fepl1">
                  <Check size={16} className="text-emerald-brand shrink-0 mt-0.5" data-id="element-152" data-mp="hfx8plemn9k4" />
                  <span data-id="element-153" data-mp="mes0hcuko8gd">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-154" data-mp="7jc1ctf4xmd4">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-155" data-mp="cioqjkthb5iv">
                <span className="text-2xl md:text-3xl text-navy-medium" data-id="element-156" data-mp="ckhvmvog1hor">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-navy" data-id="element-157" data-mp="3uvcy5xhr7f46">$27 USD</span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-158" data-mp="3kyi6nyjweeze">
              🟡 GET TAEKWONDO INSTRUCTOR READY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-ink-soft mb-4" data-id="element-159" data-mp="3bylma94jk2a5">
              <span className="flex items-center gap-1.5" data-id="element-160" data-mp="3fylydn4641e1">
                <Lock size={12} className="text-emerald-brand" data-id="element-161" data-mp="2xabjnt9wsxua" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-162" data-mp="2scs66vl1cp3e">
                <Zap size={12} className="text-emerald-brand" data-id="element-163" data-mp="2secw27wenjux" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-164" data-mp="31coma8td0fmu">
                <Check size={12} className="text-emerald-brand" data-id="element-165" data-mp="31b55mh3sk2kj" /> Digital PDF Bundle
              </span>
            </div>

            <div className="bg-cream-beige border border-gold-light rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-166" data-mp="3g7uritkmsaf4">
              <Globe className="text-navy shrink-0 mt-0.5" size={14} data-id="element-167" data-mp="3p2snyamzm5b7" />
              <p className="text-[11px] text-ink-soft leading-snug" data-id="element-168" data-mp="3p43s4bkchf2u">
                🌍 Payment availability and currency conversion may vary according to your checkout
                provider and country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}